import { MenuItemProps } from "@mui/material";

import AppMenuItem from "./AppMenuItem";

interface OwnProps {
  isLoading?: boolean;
  loadingText?: string;
  onClick?: MenuItemProps["onClick"] | (() => void | Promise<void>);
  children?: MenuItemProps["children"];
}

export type LoadingMenuItemProps = OwnProps & Omit<MenuItemProps, "onClick" | "children">;

/** @deprecated Use `AppMenuItem`. Show loader if loading is passed or while onClick is being processed. */
export default function LoadingMenuItem({
  isLoading,
  loadingText,
  onClick,
  children,
  ...menuItemProps
}: LoadingMenuItemProps) {
  return (
    <AppMenuItem
      isLoading={isLoading}
      loadingText={loadingText}
      onClick={onClick}
      {...menuItemProps}
    >
      {children}
    </AppMenuItem>
  );
}
